import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ProductCardContext = /*#__PURE__*/createContext(null);
const ProductCardContextProvider = _ref => {
  let {
    productData,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(ProductCardContext.Provider, {
    value: productData,
    children: children
  });
};
export const useProductCardContext = () => {
  const context = useContext(ProductCardContext);
  if (!context) {
    throw new Error('useProductCardContext must be used within a ProductCardContextProvider');
  }
  return context;
};
export default ProductCardContextProvider;
//# sourceMappingURL=ProductCardContext.js.map